export default __webpack_public_path__ + "static/media/add.e90adc6a.svg";